// lib

import PropTypes from 'prop-types'

// components
import ControlsComponents from '@aytm/app/stats/page/question-views/oe/components/ControlsComponents'

// styles
import style from '@aytm/app/stats/page/question-views/oe/components/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const Controls = ({ disabled, ...props }) =>
  disabled ? null : (
    <div className={`${style.component} ${NO_PRINT}`}>
      <ControlsComponents {...props} />
    </div>
  )

Controls.propTypes = {
  disabled: PropTypes.bool
}

Controls.displayName = 'Controls'

export default Controls
